// @flow
import * as React from 'react';
import ClientOnly from 'containers/ClientOnly';
import Box from 'components/Box';
import { Line as LoadingLine } from 'components/SearchLoadingSection';
import PrintHidden from 'components/PrintHidden';
import Breadcrumbs from 'components/Breadcrumbs';
import PostSearchInputContainer from 'containers/PostSearchInputContainer';
import type { Subsite } from 'api/website';
import type { Page } from '../redux/main/reducers/pages';
import { colors, gutterWidth, shadows } from '../theme';

const SearchToolbar = ({
  content,
  subsite,
  searchMode
}: {
  content: Page,
  subsite: Subsite,
  searchMode: boolean
}) => {
  const homePage = subsite.homePage;
  const isHomePage = homePage && homePage.url === content.url;
  const hasBreadcrumbs = !isHomePage || (isHomePage && searchMode);
  const links = [
    {
      title: homePage.title,
      to: `/${subsite && homePage.url}`,
      'data-qa-id': 'breadcrumbs-home-link'
    }
  ];
  if (!isHomePage) {
    links.push({
      title: content.title,
      to: { pathname: `/${content.url}`, state: { subsite } }
    });
  }
  return (
    <PrintHidden>
      <Box
        data-qa-id="search-toolbar"
        position="relative"
        zIndex="1"
        py={12}
        px={gutterWidth / 2}
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        bg={colors.white}
        borderTop={`1px solid ${colors.platinum}`}
        boxShadow={shadows.toolbar}
      >
        <Box width="50%" flex="0 0 auto" pr={16}>
          {hasBreadcrumbs && (
            <ClientOnly
              placeholder={
                <Box display="flex" alignItems="center">
                  <LoadingLine width={120} height={12} />
                  <LoadingLine
                    width="8px"
                    height="8px"
                    mx={20}
                    borderRadius="50%"
                  />
                  <LoadingLine width={160} height={12} />
                </Box>
              }
            >
              <Breadcrumbs links={links} />
            </ClientOnly>
          )}
        </Box>
        <Box
          width={586}
          maxWidth="50%"
          justifyContent="flex-end"
          display="flex"
        >
          <PostSearchInputContainer homePageUrl={subsite.homePage.url} />
        </Box>
      </Box>
    </PrintHidden>
  );
};

export default SearchToolbar;
